module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgNTAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojNGZmZjQ1O308L3N0eWxlPjwvZGVmcz48dGl0bGU+aGFsZi1jaXJjbGU8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE2OC02OEExMTgsMTE4LDAsMCwxLDUwLDUwLDExOCwxMTgsMCwwLDEtNjgtNjgiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/half-circle.svg
// module id = ryA8
// module chunks = 1